module.exports = __webpack_public_path__ + "images/warning-35acc5.svg";